import { useQuery } from '@apollo/client';
import { HAS_LATE_CHECKOUT_FOR_CUSTOM_JOB } from '../graphql/queries';

/**
 * Custom hook to check if a CHECKIN job has a late checkout flag
 * This is used for all CHECKIN service type jobs to ensure consistent late checkout detection
 * based on nearby reservations, including when jobs are moved to checkout dates
 * 
 * @param {Object} job - The job object
 * @returns {Object} - Contains hasLateCheckout boolean and loading state
 */
export const useLateCheckoutForCustomJob = (job) => {
  // Query for ALL CHECKIN service type jobs to ensure consistent late checkout detection
  // This fixes the issue where CHECKIN jobs moved to checkout dates don't show late checkout flags
  const shouldQuery = job && 
                      job.serviceType?.timeBase === 'CHECKIN' &&
                      job.property?.id && 
                      job.scheduledDate;

  // Convert scheduledDate timestamp to date string for GraphQL
  const jobDateString = job?.scheduledDate ? new Date(job.scheduledDate).toISOString().split('T')[0] : '';


  const { data, loading, error } = useQuery(HAS_LATE_CHECKOUT_FOR_CUSTOM_JOB, {
    variables: {
      propertyId: job?.property?.id || '',
      jobDate: jobDateString
    },
    skip: !shouldQuery,
    // Cache for 5 minutes since reservation times don't change frequently
    fetchPolicy: 'cache-first',
    nextFetchPolicy: 'cache-first',
    // Only refetch if variables change
    notifyOnNetworkStatusChange: false,
    
    onError: (error) => {
      // Error handling - could be logged to monitoring service in production
    }
  });

  const result = {
    hasLateCheckout: data?.hasLateCheckoutForCustomJob || false,
    loading: shouldQuery ? loading : false,
    error: shouldQuery ? error : null
  };

  return result;
};

export default useLateCheckoutForCustomJob;